import beautifulThumbnail from '../images/video-thumbnales/beautiful.jpg'
import gospelThumbnail from '../images/video-thumbnales/gospel.jpg'
import incantationThumbnail from '../images/video-thumbnales/incantation.jpg'
import motherlessChildThumbnail from '../images/video-thumbnales/motherlesschild.jpg'
import sinceYouLeftThumbnail from '../images/video-thumbnales/sinceyouleft.jpg'
import morningThumbnail from '../images/video-thumbnales/morning.jpg'
import soundObjectsThumbnail from '../images/video-thumbnales/soundobjects.jpg'
import trinaglesThumbnail from '../images/video-thumbnales/triangles.jpg'

import severinsenThumbnail from '../images/video-thumbnales/severinsen.jpg'
import concertoSegalThumbnail from '../images/video-thumbnales/segalconcerto.jpg'
import naturalWomenThumbnail from '../images/video-thumbnales/naturalwomen.jpg'
import tubachatThumbnail from '../images/video-thumbnales/tubachat.jpg'
import deepDarkThumbnail from '../images/video-thumbnales/deepdark.png'

const videoTable = [
  {
    title: 'Deep, Dark Night',
    description: 'Original composition - Drew Bonner',
    thumbnail: deepDarkThumbnail,
    youtubeLink: 'https://www.youtube.com/embed/HWdSKQs15DE',
    id: 13,
  },
  {
    title: 'Sometimes I Feel Like a Motherless Child',
    description: 'Featuring Kikora Franklin, dancer.',
    thumbnail: motherlessChildThumbnail,
    youtubeLink: 'https://www.youtube.com/embed/FNWKLVfWGA0',
    id: 12,
  },
  {
    title: 'Triangles',
    description:
      'Featuring Laurel Ohlson, horn, and Dr. Jeannie Little, trombone.',
    thumbnail: trinaglesThumbnail,
    youtubeLink: 'https://www.youtube.com/embed/gJ-8vDcjllk',
    id: 11,
  },
  {
    title: 'Since You Left',
    description: 'Featuring Ron Stabinsky, piano.',
    thumbnail: sinceYouLeftThumbnail,
    youtubeLink: 'https://www.youtube.com/embed/Q19GtO6TEYo',
    id: 10,
  },
  {
    title: 'Sound Objects #1, #2, #3',
    description:
      'Second and third movements from Meyer Kupferman "Sound Objects #1, #2, #3".',
    thumbnail: soundObjectsThumbnail,
    youtubeLink: 'https://www.youtube.com/embed/P7Ib3TFPFWw',
    id: 9,
  },
  {
    title: 'How Beautiful',
    description:
      'Featuring Maria Malizia, dancer, and Dr. Anthony Leach, piano.',
    thumbnail: beautifulThumbnail,
    youtubeLink: 'https://www.youtube.com/embed/cFPAVoqtfSc',
    id: 8,
  },
  {
    title: 'Incantation',
    description: 'Featuring Ron Stabinsky, piano.',
    thumbnail: incantationThumbnail,
    youtubeLink: 'https://www.youtube.com/embed/a5p3xFAqif4',
    id: 7,
  },
  {
    title: 'Gospel Offering',
    description:
      'Featuring Chad Hughes, keyboards, Meredith Fuller, tuba, Calvin Morris, trombones, and Tyrone Owens, drums',
    thumbnail: gospelThumbnail,
    youtubeLink: 'https://www.youtube.com/embed/oyNzVrAlB7A',
    id: 6,
  },
  {
    title: 'A Very Good Morning from Pearls',
    description: 'Featuring Ron Stabinsky, piano.',
    thumbnail: morningThumbnail,
    youtubeLink: 'https://www.youtube.com/embed/-8T_OT2Bruw',
    id: 5,
  },
  {
    title: 'Stiletto Brass Quintet with Doc Severinsen',
    description:
      'The Stiletto Brass Quintet plays a scheduled event for The Great American Brass Band Festival on June 8, 2012, at the Beaumont Inn located in Harrodsburg, Kentucky, USA.  Special guest Doc Severinsen joins the group.',
    thumbnail: severinsenThumbnail,
    youtubeLink: 'https://www.youtube.com/embed/2odQ1Jhj_0o',
    id: 4,
  },
  {
    title: 'Concerto for Tuba by Anna Segal',
    description:
      'Tuba Concerto "Incantation" with amazing Velvet Brown, legendary tuba player maestro Roger Bobo, conductor Gerardo Edelstein and Philharmonic orchestra of Penn State University.',
    thumbnail: concertoSegalThumbnail,
    youtubeLink: 'https://www.youtube.com/embed/H1sumu479Cs',
    id: 3,
  },
  {
    title: 'Howard Johnson and Gravity: Evolution and Natural Woman',
    description:
      'Howard Johnson and Gravity performing Evolution (Bob Nelloms) and Natural Women (Carol King) at The Bitter End during 2014 Winter JazzFest.',
    thumbnail: naturalWomenThumbnail,
    youtubeLink: 'https://www.youtube.com/embed/qahHKhkLQak',
    id: 2,
  },
  {
    title: 'Tuba Chat with Velvet Brown',
    description:
      'Listen to Velvet talk about her both her life, and teaching during COVID-19 with Jarrett McCourt and Chuck Daellenbach from the canadian brass',
    thumbnail: tubachatThumbnail,
    youtubeLink: 'https://www.youtube.com/embed/_5SebaSG7WA',
    id: 1,
  },
]

export default videoTable
